/** Referencia fija de cuerdas al aire (afinación estándar). Cuerda 6 = grave. */
export type OpenStringRef = {
  string: number;
  note: string;
  midiLabel: string;
  role: "grave" | "media" | "aguda";
};

export const OPEN_STRINGS_REFERENCE: OpenStringRef[] = [
  { string: 6, note: "Mi", midiLabel: "E2", role: "grave" },
  { string: 5, note: "La", midiLabel: "A2", role: "grave" },
  { string: 4, note: "Re", midiLabel: "D3", role: "grave" },
  { string: 3, note: "Sol", midiLabel: "G3", role: "media" },
  { string: 2, note: "Si", midiLabel: "B3", role: "aguda" },
  { string: 1, note: "Mi", midiLabel: "E4", role: "aguda" },
];

/** Mnemotécnica clásica 6→1 (español). */
export const OPEN_STRINGS_MNEMONIC =
  "Esto Es Un Juego, no es Más que un juego → Mi–La–Re–Sol–Si–Mi";

export const OPEN_STRINGS_ORDER_SHORT = "6→1: E · A · D · G · B · e";

export const GUITAR_BASICS_REFERENCE_TIPS = [
  "Cuerda 6 (arriba en el mástil digital) = la más gruesa / grave.",
  "Cuerda 1 (abajo) = la más delgada / aguda.",
  "Al aire = traste 0: no pises ningún traste.",
  "Un traste más arriba = un semitono más agudo.",
] as const;
